export default {
  // Steps navigation
  steps_company_info: 'Información de la empresa',
  steps_company_document: 'Documentos de la empresa',
  steps_signatory_info: 'Información del firmante',
  steps_shareholder_info: 'Información del accionistas / Beneficiario final (UBO)',
  steps_account_info: 'Información de la cuenta',
  // Common
  title: 'Verificación KYC',
  yes: 'Sí',
  no: 'No',
  save_as_draft: 'Guardar borrador',
  upload_document: 'Subir documento',
  upload_tip: 'Asegúrese de que el texto de la imagen subida sea claro y visible.',
  upload_format: '(Máx. 10 MB, formatos admitidos: JPG, JPEG, PNG o PDF)',
  upload_format_short: 'Máx. 10 MB, JPG/JPEG/PNG/PDF',
  to: 'a',
  // Step 1: Company Information
  company_info_subtitle: 'Seleccione su tipo de negocio',
  company_info_business_type_corporation: 'Persona jurídica / Sociedad anonima',
  company_info_business_type_sole_proprietorship: 'Empresa unipersonal',
  company_info_company_type: 'Tipo de empresa',
  company_info_legal_name_en: 'Nombre de la empresa',
  company_info_registration_number: 'Número de registro de la empresa',
  company_info_date_of_incorporation: 'Fecha de constitución',
  company_info_date_of_expiry: 'Fecha de vencimiento de la sociedad',
  company_info_tax_id: 'Número de identificación fiscal',
  company_info_registration_address: 'Dirección de registro de la empresa',
  company_info_same_business_address: '¿La dirección operativa real es la misma que la dirección de registro?',
  company_info_brand_name: 'Nombre comercial',
  company_info_business_website: 'Sitio web de la empresa',
  company_info_business_scope: 'Alcance del negocio',
  company_info_mcc: 'Código de categoría del comercio (MCC)',
  company_info_monthly_transaction: 'Volumen de transacciones mensuales',
  company_info_type_of_business: 'Tipo de negocio',
  company_info_exchange_name: 'Nombre de la bolsa de valores',
  company_info_stock_code: 'Código de cotización',
  company_info_settlement_currency: 'Moneda de liquidación (USD o moneda local)',
  company_info_settlement_account_location: 'Ubicación de la cuenta de liquidación',
  company_info_settlement_account_name: 'Nombre de la cuenta de liquidación',
  company_info_settlement_account_number: 'Número de la cuenta de liquidación',
  company_info_swift_code: 'Código Swift (obligatorio para liquidación en USD)',
  company_info_settlement_account_address: 'Dirección de la cuenta de liquidación',
  company_info_settlement_account_proof: 'Comprobante de la cuenta de liquidación',
  company_info_placeholder_enter_legal_name: 'Ingrese la razón social de la empresa',
  company_info_placeholder_enter_registration_number: 'Ingrese el número de registro de la empresa',
  company_info_placeholder_enter_tax_id: 'Ingrese el número de identificación fiscal',
  company_info_placeholder_enter_registration_address: 'Ingrese la dirección de registro',
  company_info_placeholder_enter_brand_name: 'Ingrese el nombre comercial',
  placeholder_enter_website: 'Ingrese el sitio web de la empresa',
  placeholder_enter_business_scope: 'Ingrese el alcance del negocio',
  placeholder_enter_mcc: 'Ingrese el código de categoría del comercio',
  placeholder_enter_amount: 'Ingrese el monto de transacción mensual',
  placeholder_enter_business_type: 'Ingrese el tipo de negocio',
  placeholder_enter_exchange_name: 'Ingrese el nombre de la bolsa de valores',
  placeholder_enter_stock_code: 'Ingrese el código de cotización',
  company_info_placeholder_enter_swift_code: 'Ingrese el código Swift',
  company_info_placeholder_search: 'Buscar',
  company_info_placeholder_enter_address_to_search: 'Ingrese la dirección para buscar',
  company_info_placeholder_enter_name_to_search: 'Ingrese el nombre para buscar',
  company_info_placeholder_enter_account_address_to_search: 'Ingrese la dirección de la cuenta para buscar',
  company_info_company_type_option_limited: 'Sociedad de Responsabilidad Limitada',
  company_info_company_type_option_partnership: 'Asociación',
  company_info_company_type_option_sole: 'Empresa unipersonal',
  company_info_currency_option_usd: 'USD (Dólar estadounidense)',
  company_info_currency_option_thb: 'THB (Baht tailandés)',
  company_info_currency_option_sgd: 'SGD (Dólar de Singapur)',
  company_info_currency_option_other: 'Otra moneda',
  // extra common fields (placeholders + validation)
  phone_number: 'Teléfono de contacto',
  email: 'Correo electrónico de contacto',
  full_name: 'Nombre completo del contacto',
  store_photo: 'Foto de la tienda',
  placeholder_enter_phone: 'Ingrese el teléfono de contacto',
  placeholder_enter_email: 'Ingrese el correo electrónico',
  placeholder_enter_name: 'Ingrese el nombre completo',
  placeholder_date: 'YYYY-MM-DD',
  validation_phone_required: 'Por favor, ingrese el número de teléfono',
  validation_phone_invalid: 'Por favor, ingrese un número de teléfono válido que comience con 08',
  validation_email_required: 'Por favor, ingrese el correo electrónico',
  validation_email_invalid: 'Por favor, ingrese una dirección de correo electrónico válida',
  validation_full_name_required: 'Por favor, ingrese el nombre del contacto',
  validation_upload_company_registration: 'Por favor, suba el certificado de registro de la empresa',
  validation_upload_articles: 'Por favor, suba el acta constitutiva',
  validation_upload_tax_documents: 'Por favor, suba los documentos fiscales',
  validation_upload_business_permit: 'Por favor, suba el permiso comercial',
  // Step 2: Company Document
  company_document_articles_of_association: 'Acta constitutiva',
  company_document_registration_certificate: 'Certificado de registro de la empresa',
  company_document_tax_documents: 'Documentos fiscales',
  company_document_business_permit: 'Permiso comercial',
  company_document_license_permit: 'Permiso de licencia',
  company_document_annual_report: 'Documentos de auditoría anual',
  company_document_other_documents: 'Otros documentos',
  // Step 3: Signatory Information
  signatory_info_subtitle: 'Seleccione el tipo de documento de identidad',
  signatory_info_id_type_etc: 'Otros.',
  signatory_info_id_type_passport: 'Pasaporte',
  signatory_info_nationality: 'Nacionalidad',
  signatory_info_id_type: 'Tipo de documento',
  signatory_info_legal_name_en: 'Nombre legal',
  signatory_info_first_name: 'nombre',
  signatory_info_middle_name: 'Segundo nombre',
  signatory_info_last_name: 'Apellidos',
  signatory_info_position: 'Cargo del firmante',
  signatory_info_date_of_birth: 'Fecha de nacimiento',
  signatory_info_residential_address: 'Dirección residencial',
  signatory_info_id_photo: 'Foto del documento de identidad',
  signatory_info_taxpayer_identity: 'Identidad fiscal',
  signatory_info_authorization_letter: 'Poder notarial',
  signatory_info_id_number: 'Número de documento',
  signatory_info_id_photo_front: 'Foto de documento (frente)',
  signatory_info_id_photo_back: 'Foto de documento (reverso)',
  placeholder_enter_id_number: 'Ingrese el número de documento',
  validation_id_number_required: 'Por favor, ingrese el número de documento de identidad',
  validation_id_number_format: 'El número de documento solo puede contener letras y números',
  validation_document_type_required: 'Por favor, seleccione el tipo de documento',
  validation_nationality_required: 'Por favor, seleccione la nacionalidad',
  signatory_info_add_email: 'Añadir correo electrónico / Añadir otro correo',
  signatory_info_placeholder_enter_residential_address: 'Ingrese la dirección de residencia',
  signatory_info_placeholder_enter_email: 'Ingrese el correo electrónico',
  signatory_info_nationality_option_th: 'Tailandia',
  signatory_info_nationality_option_sg: 'Singapur',
  signatory_info_nationality_option_other: 'Otro',
  signatory_info_position_option_director: 'Director',
  signatory_info_position_option_auth_signatory: 'Firmante autorizado',
  signatory_info_position_option_other: 'Otro',
  // Step 4: Shareholder Information
  shareholder_info_subtitle: 'Seleccione el tipo de documento de identidad',
  shareholder_info_id_type_etc: 'Otros.',
  shareholder_info_id_type_passport: 'Pasaporte',
  shareholder_info_id_photo: 'Foto del documento de identidad',
  shareholder_info_id_photo_front: 'Foto de documento (frente)',
  shareholder_info_id_photo_back: 'Foto de documento (reverso)',
  shareholder_info_shareholding_ratio: 'Porcentaje de participación / Acciones (%)',
  shareholder_info_add_shareholder: 'Añadir accionista / Añadir otro accionista',
  shareholder_info_placeholder_enter_shareholding_ratio: 'Ingrese el porcentaje de participación (ej. 25)',
  // Step 5: Account Information
  account_info_subtitle: 'Seleccione el tipo de documento de identidad',
  account_info_id_type_etc: 'Otros.',
  account_info_id_type_passport: 'Pasaporte',
  account_info_settlement_currency: 'Moneda de liquidación (USD o moneda local)',
  account_info_settlement_account_location: 'Ubicación de la cuenta de liquidación',
  account_info_settlement_account_name: 'Nombre de la cuenta de liquidación',
  account_info_settlement_account_number: 'Número de la cuenta de liquidación',
  account_info_swift_code: 'Código Swift (obligatorio para liquidación en USD)',
  account_info_settlement_account_address: 'Dirección de la cuenta de liquidación',
  account_info_settlement_account_proof: 'Comprobante de la cuenta de liquidación',
  account_info_placeholder_enter_address_to_search: 'Ingrese la dirección para buscar',
  account_info_placeholder_enter_name_to_search: 'Ingrese el nombre para buscar',
  account_info_placeholder_enter_settlement_account_number: 'Ingrese el número de la cuenta de liquidación',
  account_info_placeholder_enter_swift_code: 'Ingrese el código Swift',
  account_info_placeholder_enter_account_address_to_search: 'Ingrese la dirección de la cuenta para buscar',
  account_info_currency_option_usd: 'USD',
  account_info_currency_option_thb: 'THB',
  account_info_currency_option_sgd: 'SGD',
  account_info_currency_option_other: 'Otro',
  // Account page - bank fields
  account_info_bank_name: 'Nombre del banco',
  account_info_account_name: 'Nombre de la cuenta',
  account_info_account_number: 'Número de la cuenta',
  account_info_account_proof: 'Comprobante de la cuenta',
  account_info_placeholder_bank_name: 'Ingrese el nombre del banco',
  account_info_placeholder_account_name: 'Ingrese el nombre de la cuenta bancaria',
  account_info_placeholder_account_number: 'Ingrese el número de la cuenta',
  save_draft_success: 'Borrador guardado con éxito',
  saving: 'Guardando...',
  save_failed: 'Error al guardar',
  upload_debounce_warning: 'Operación demasiado frecuente, por favor intente de nuevo en unos momentos',
  upload_required: 'Por favor suba el archivo requerido para: {field}',
  next_step: 'Siguiente paso',
  submit_application: 'Enviar solicitud',
  submit_success: 'Solicitud enviada con éxito',
  // Exit dialog
  exit_dialog_title: 'Completar verificación de identidad',
  exit_with_unsaved: 'Está a punto de salir de esta página. Hay datos que no han sido guardados. ¿Desea guardarlos ahora?',
  first_step_required: 'Primero debe completar la información básica del Paso 1',
  cancel: 'Cancelar',
  save: 'Guardar',
  // Pending popup
  pending_popup_title: 'Atención: Acción requerida urgente',
  pending_popup_tip: 'Aún no ha enviado su información de verificación. Por favor, proceda a realizar la verificación KYC (asegúrese de tener listos sus documentos).',
  pending_rejected_tip: 'Su cuenta cuenta con tareas pendientes de resolución. Para evitar interrupciones en el servicio, le recomendamos solucionarlas de inmediato.',
  pending_rejected_message: 'Su información de verificación fue rechazada. Por favor, modifíquela y envíela de nuevo.',
  pending_business_type: 'Tipo de operación',
  pending_todo: 'Tareas pendientes',
  pending_operation: 'Acción',
  pending_business_account_verification: 'Verificación de cuenta de negocio',
  pending_todo_intro: 'Aún no ha enviado los datos de identidad requeridos, por favor complete la verificación KYC (prepare la documentación necesaria de antemano).',
  pending_item_1: 'Información básica de la empresa (Datos de contacto, situación operativa, información transaccional, etc.)',
  pending_item_2: 'Certificado de registro, acta constitutiva, documentos fiscales, licencias comerciales, etc.',
  pending_item_3: 'Información de los registrantes / firmantes de la empresa (Fotos y números de documentos de identidad, etc.)',
  pending_item_4: 'Detalles de la cuenta bancaria de liquidación',
  pending_setup_now: 'Configurar ahora',
  // Verify Now popup
  verify_popup_title: 'Completar verificación de identidad',
  verify_main: 'Se requiere realizar la verificación KYC de su cuenta',
  verify_sub: 'Para garantizar el uso normal y seguro de los servicios de PayCools, por favor realice primero la verificación de su cuenta.',
  verify_now: 'Verificar ahora',
  verifying_title: 'Verificación KYC en proceso de revisión',
  verifying_main: 'Su verificación KYC está siendo revisada',
  verifying_sub: 'Estamos validando su información. Una vez aprobada, la función se habilitará automáticamente. Agradecemos su paciencia.',
  confirm: 'Confirmar',
  rejection_title: 'Por favor, cumpla con los siguientes requisitos: ',
  // validation messages
  validation_company_name_required: 'Por favor, ingrese el nombre de la empresa',
  validation_company_registration_required: 'Por favor, ingrese el número de registro de la empresa',
  validation_date_of_incorporation_required: 'Por favor, ingrese la fecha de constitución / registro',
  validation_tax_id_required: 'Por favor, ingrese el número de identificación fiscal',
  validation_registration_address_required: 'Por favor, ingrese la dirección de registro de la empresa',
  validation_brand_name_required: 'Por favor, ingrese el nombre comercial / marca',
  validation_business_website_required: 'Por favor, ingrese el sitio web de la empresa',
  validation_business_website_format: 'Por favor, ingrese un enlace válido que comience con http:// o https://',
  validation_business_scope_required: 'Por favor, ingrese el alcance del negocio',
  validation_store_photo_required: 'Por favor, suba la fotografía de sus instalaciones / oficinas',
  validation_mcc_required: 'Por favor, ingrese el código de categoría de comercio (MCC)',
  validation_monthly_transaction_required: 'Por favor, ingrese el volumen de transacciones mensuales',
  validation_company_type_required: 'Por favor, seleccione el tipo de empresa',
  validation_business_address_required: 'Por favor, ingrese la dirección operativa de la empresa',
  validation_type_of_business_required: 'Por favor, ingrese el tipo de negocio',
  validation_exchange_name_required: 'Por favor, ingrese el nombre de la bolsa de valores',
  validation_stock_code_required: 'Por favor, ingrese el código de cotización',
  validation_bank_name_required: 'Por favor, ingrese el nombre del banco',
  validation_account_name_required: 'Por favor, ingrese el nombre del titular de la cuenta',
  validation_account_number_required: 'Por favor, ingrese el número de cuenta bancaria',
  validation_account_proof_required: 'Por favor, suba el documento comprobante de la cuenta bancaria',
  validation_idfront_required: 'Por favor, suba la foto frontal del documento de identidad',
  validation_idback_required: 'Por favor, suba la foto posterior del documento de identidad',
  validation_authorization_letter_required: 'Por favor, suba la carta de autorización firmada',
  validation_position_required: 'Por favor, ingrese el cargo del firmante autorizado',
  validation_all_fields_required: 'Por favor, complete todos los campos obligatorios',
  validation_length_20_30: 'La longitud permitida es de entre 20 y 30 caracteres',
  validation_length_100: 'La longitud permitida es de entre 1 y 100 caracteres',
  validation_length_500: 'La longitud permitida es de entre 1 y 500 caracteres',
  // Dashboard KYC banner
  dashboard_kyc_title: 'Verificación de cuenta',
  dashboard_kyc_subtitle: 'Complete el proceso de identidad KYC para desbloquear el máximo potencial de su negocio',
  dashboard_kyc_btn_text: 'Ir a verificar',
  // Remove confirmation
  confirm_remove_file: '¿Está seguro de que desea eliminar el archivo {name}?',
  // File limit exceeded validation
  validation_file_limit_exceeded: '¡El límite actual es de {limit} archivo(s). ¡Por favor, elimine algún archivo antes de volver a intentar la carga!!'
}
